import { AppConfig } from ".";

export const stagingConfig: AppConfig = {
    apiUrl: 'https://mss-staging-app.azurewebsites.net',
    dashboardUrl: 'https://staging.dashboard.mysportset.com',
    firebaseConfig: {
        apiKey: "AIzaSyDMMxbOctudxmz7ZC3Lhpk7U3ARsIP1SwY",
        authDomain: "padelfzco-admin-staging.firebaseapp.com",
        projectId: "padelfzco-admin-staging",
        storageBucket: "padelfzco-admin-staging.firebasestorage.app",
        messagingSenderId: "54735181821",
        appId: "1:54735181821:web:b4d6d91b20cabe3d6d6b94"
    },
    sentryConfig: {
        dsn: 'https://35ba1ee64b851d42c40e829c4c8cb2fd@o4508978380341248.ingest.de.sentry.io/4509043064111184',
        tracesSampleRate: 1
    },
    posthogConfig: {
        apiKey: 'phc_OFl8at7KpJwYBteXCN4Vg23rA76a1YvAtKp89NklToJ',
        host: 'https://ph.staging.mysportset.com'
    }
};